import { createFileRoute } from '@tanstack/react-router';
import { OrganigramPage } from '@/pages/organization/organigram/OrganigramPage';
import { createCaslGuard } from '@/lib/auth/permissionGuards';

export const Route = createFileRoute('/$slug/organigram/')({
  component: OrganigramPage,
  beforeLoad: createCaslGuard('OrgChart')
});
